import baseUrl from '../configs/baseUrl';
import { getLastSubId } from './commonUtils';
import { PrintDate, PrintTime } from './timeParser';

export function browserNotification(title = '', options) {
  try {
    Notification.requestPermission();
    const n = new Notification(title, options);
    if (Object.prototype.hasOwnProperty.call(options, 'time')) {
      const c = setTimeout(() => {
        n.close();
      }, options?.time);
      clearTimeout(c);
    }
    return true;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const notificationWording = (params) => {
  const type = params?.type ?? 1;
  const memberName = params?.body?.data?.user?.name ?? '';
  const memberEmail = params?.body?.data?.user?.email ?? '';
  const teamName = params?.body?.data?.team?.name ?? '';
  const licenseName = params?.body?.data?.license?.name ?? '';
  const originRoleName = params?.body?.data?.origin_role?.name ?? '';
  const destinationRoleName = params?.body?.data?.destination_role?.name ?? '';
  const roleName = params?.body?.data?.role?.name ?? '';
  const transactionId = params?.body?.data?.transaction?.id
    ? getLastSubId(params?.body?.data?.transaction?.id)
    : '';
  const tmpDate = params?.created_at;
  const parsedDate = `${PrintDate(tmpDate)} ${PrintTime(tmpDate)}`;

  if (type === 1) {
    return `${teamName} purchased license ${licenseName} on ${parsedDate} with payment id ${transactionId} `;
  }

  if (type === 2) {
    return `Payment with id ${transactionId} have been accepted on ${parsedDate} `;
  }

  if (type === 3) {
    return `Payment with id ${transactionId} have been rejected on ${parsedDate} `;
  }

  if (type === 4) {
    return `${memberName} (${memberEmail}) has joined the ${teamName} team. `;
  }

  if (type === 5) {
    return `${roleName} has assigned to ${memberName}. `;
  }

  return `User role ${memberName} has changed from role ${originRoleName} to role ${destinationRoleName} `;
};

export const notificationRedirect = (params, history) => {
  const type = params?.type ?? 1;
  if (type === 1 || type === 2 || type === 3) {
    history.push(baseUrl.TEAM_SETTINGS_LICENSE);
  }

  if (type === 4 || type === 5) {
    history.push(baseUrl.MEMBERS);
  }
};
